import { Tabs as TabsCore } from '@studiometa/ui';

export default class Tabs extends TabsCore {
  get btnContainer() {
    return this.$refs.btn[0].parentElement;
  }

  /**
   * Enable the given tab and its associated content.
   */
  enableItem(item) {
    super.enableItem(item);
    this.btnContainer.scrollTo({
      left: item.btn.offsetLeft - (this.btnContainer.offsetWidth - item.btn.offsetWidth) / 2,
      behavior: 'smooth',
    });
  }
}
